export const DGATE_CT_APP_VERSION = 'v0.0';

export const DGATE_CAMPAIGN_TRACKER_PAGE_LAYOUT_VERSION = 'v1';
